import { backendAPI } from "../api"
import { safeApiCall } from "../api/offline"

export const memberTransactionAggregLoadingStarted = (bool) => ({
  type: "MEMBER_TRANSACTION_AGGREGATE_LOAD_START",
  isloading: bool,
})

export const transactionsAggregLoaded = (aggreg) => ({
  type: "LOADED_TRANSACTION_AGGREG",
  aggreg,
})

export const transactionsAggregLoadError = (error) => ({
  type: "TRANSACTION_AGGREG_LOAD_ERROR",
  error: error,
})

export function fetchTransactionsAggreg(memberId) {
  return async function (dispatch, getState) {
    dispatch(memberTransactionAggregLoadingStarted(true))
    const member = getState().loadedMember
    const id = memberId || member?.id
    try {
      // if (id) {
      //   return
      // }
      // const url = `/members/${id}/balances`
      // const { data } = await safeApiCall(
      //   {
      //     cacheEnabled: true,
      //     url: url,
      //   },
      //   async () => backendAPI.get(url),
      // )
      // dispatch(transactionsAggregLoaded(data))
      // dispatch(memberTransactionAggregLoadingStarted(false))
      return Promise.resolve()
    } catch (error) {
      dispatch(transactionsAggregLoadError(error))
      dispatch(memberTransactionAggregLoadingStarted(false))
      return Promise.reject()
    }
  }
}
